import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CokieLawComponent } from './cookie-law.component';

import { CookieLawService } from './cookie-law.service';

@NgModule({
  declarations: [
    CokieLawComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule
  ],
  exports: [
    CokieLawComponent
  ],
  providers: [
    CookieLawService
  ]
})

export class CookieLawModule { }


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/shared/cookie-law/cookie-law.module.ts